import { ManageSupplier, ManageSupplierStatus } from 'src/types/manage-suppliers/ManageSupplier';

export type SupplierTransmissionType = 'logOnly' | 'email';

export type SupplierEmailValidationStatus = 'none' | 'pending' | 'validated' | 'failed';

export type SupplierEditMode =
  | 'full'
  | 'crossCompany'
  | 'transmissionOnly'
  | 'online'
  | 'statusOnly'
  | 'view';

export interface SupplierFormValues {
  supplierName: string;
  status: ManageSupplierStatus;
  externalSupplierName: string;
  apId: string;
  accountNumber: string;
  address1: string;
  address2: string;
  city: string;
  stateProvince: string;
  zipPostalCode: string;
  country: string;
  contactName: string;
  phone: string;
  orderEmail: string;
  transmissionType: SupplierTransmissionType;
}

export type SupplierFormFieldKey = keyof SupplierFormValues;

export type SupplierFormBaseFieldKey = Exclude<SupplierFormFieldKey, 'status'>;

export type SupplierFieldAccess = Record<SupplierFormFieldKey, boolean>;

export type SupplierRequiredFields = Record<'apId' | 'externalSupplierName', boolean>;

export const NO_REQUIRED_SUPPLIER_FIELDS: SupplierRequiredFields = {
  apId: false,
  externalSupplierName: false,
};

export interface ManageSupplierEditContext extends ManageSupplier {
  address1: string;
  address2: string;
  transmissionType: SupplierTransmissionType;
  ownedByCompanyName: string;
  isSameCompany: boolean;
  originalExternalSupplierName: string;
  originalApId: string;
  emailValidationStatus: SupplierEmailValidationStatus;
  emailValidationDateTime?: string;
  emailValidationExpired?: boolean;
}

export const initialSupplierFormValues: SupplierFormValues = {
  supplierName: '',
  status: 'active',
  externalSupplierName: '',
  apId: '',
  accountNumber: '',
  address1: '',
  address2: '',
  city: '',
  stateProvince: '',
  zipPostalCode: '',
  country: '',
  contactName: '',
  phone: '',
  orderEmail: '',
  transmissionType: 'logOnly',
};
